import React from 'react';

import { usePathname } from 'next/navigation';

import Profile from '@editor/components/Profile/Profile';
import { User } from '@repo/domain/user';
import { withEventScope } from '@repo/event-processor';

import { links } from 'components/HeadMenu/config';
import useHeaderFunctions from 'components/HeadMenu/Header/useHeaderFunctions';
import { getActiveOption, options } from 'global/userNavigation';

interface ProfileWrapperProps {
  user: User;
  onLogOut: () => void;
  isSmall?: boolean;
}

// All components with useSearchParams should be wrapped in Suspense component
const ProfileWithSearchParams: React.FC<ProfileWrapperProps> = ({
  user,
  onLogOut,
  isSmall,
}) => {
  const pathname = usePathname();
  const { goToHelp, createTeam, handleNavigation } = useHeaderFunctions();

  return (
    <Profile
      isSmall={isSmall}
      options={options}
      profile={{ ...user, isTeam: !!user.isTeam }}
      selectedOption={getActiveOption(pathname)}
      onClickItem={handleNavigation}
      onCreateTeam={createTeam}
      onHelp={goToHelp}
      onLogOut={onLogOut}
      onProfileChanged={(): void => handleNavigation({ url: links.PROFILE })}
    />
  );
};

export default withEventScope(ProfileWithSearchParams, {
  feature: 'headMenuProfile',
});
